import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import residentIDCard from '../ImportTax/ResidentIDForm/resident-id-card.svg';
import HelperDetailList from '../ui/HelperDetailList/HelperDetailList';
import HelperDetailListItem from '../ui/HelperDetailList/HelperDetailListItem';

function ChineseResidentIDHelper(props) {
  return (
    <HelperDetailList>
      <HelperDetailListItem
        icon={residentIDCard}
        info={props.translations['deliveryOptions.resident.id.chinese.info']}
      />
    </HelperDetailList>
  );
}

ChineseResidentIDHelper.propTypes = {
  translations: PropTypes.object.isRequired,
};

const mapStateToProps = state => ({
  translations: state.lang,
});

export default connect(
  mapStateToProps,
)(ChineseResidentIDHelper);
